import { JsonSerializable } from "@/Common/Models/JsonSerializable";

class IssueAndPlanOfManagement extends JsonSerializable {
    private _id: number;

    public Issues: string;
    public PlanOfManagementOrMedicationChangeOrConsultations: string;

    constructor(fields?: Partial<IssueAndPlanOfManagement>) {
        super({ excludedFields: ["_id"] });

        Object.assign(this, fields);
        this._id = sessionStore.newId();
    }

    public getId(): number {
        return this._id;
    }

    public hasValue(): boolean {
        return !!this.Issues?.trim()
            || !!this.PlanOfManagementOrMedicationChangeOrConsultations?.trim();
    }
}

export { IssueAndPlanOfManagement };
